@use "~theme/typography";

.footer {
  background-color: rgba(white, 0.8);
  border-top: 1px solid var(--blue-01-at-30);
  padding: 8px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--footer);
}

.button {
  display: flex;
  padding: 0 16px;
  margin: 0 auto;
}

.buttons {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 0.28fr 0.72fr;
  gap: 16px;
  margin-left: auto;
  margin-right: auto;
  max-width: var(--max-desktop-width);
  width: 100%;
}

.bodyLink {
  @include typography.body-link;
  padding-top: 1.5%;
}
